import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/auth/auth.guard';
import { AlreadyAuthGuard } from './core/auth/already-auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'badge',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/login/login.module').then((m) => m.LoginPageModule),
    canActivate: [AlreadyAuthGuard],
  },
  {
    path: 'settings',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/settings/settings.module').then(
        (m) => m.SettingsPageModule
      ),
  },
  {
    path: 'badge',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/badge/badge.module').then((m) => m.BadgePageModule),
  },
  {
    path: 'dayinfo',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/day-info/dayinfo.module').then(
        (m) => m.DayinfoPageModule
      ),
  },
  {
    path: 'native-app-login',
    loadChildren: () =>
      import('./pages/native-app-login/native-app-login.module').then(
        (m) => m.NativeAppLoginPageModule
      ),
  },
  {
    path: 'report',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './components/personal/personal-time-report/personal-time-report.module'
      ).then((m) => m.PersonalTimeReportModule),
  },
  {
    path: 'orders',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/orders/orders.module').then((m) => m.OrdersPageModule),
  },
  {
    path: 'absence-planer',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/absence-planer/absence-planer.module').then(
        (m) => m.AbsencePlanerPageModule
      ),
  },
  {
    path: 'persons',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/persons/persons.module').then((m) => m.PersonsPageModule),
  },
  {
    path: 'workflow',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/workflow/workflow.module').then(
        (m) => m.WorkflowPageModule
      ),
  },
  {
    path: 'admin-tools-persons',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/admin-tools/persons/admin-tools-persons.module').then(
        (m) => m.AdminToolsPersonsPageModule
      ),
  },
  {
    path: 'admin-tools-timemodel',
    loadChildren: () =>
      import('./pages/admin-tools/timemodel/admin-tools-timemodel.module').then(
        (m) => m.AdminToolsTimemodelPageModule
      ),
  },
  // {
  //   path: 'admin-tools-department',
  //   loadChildren: () =>
  //     import(
  //       './pages/admin-tools/department/admin-tools-department.module'
  //     ).then((m) => m.AdminToolsDepartmentPageModule),
  // },
  {
    path: 'admin-tools-holiday',
    loadChildren: () =>
      import('./pages/admin-tools/holiday/admin-tools-holiday.module').then(
        (m) => m.AdminToolsHolidayPageModule
      ),
  },
  {
    path: 'reports',
    canActivate: [AuthGuard], // optional zusätzlich canLoad
    loadChildren: () =>
      import('./pages/reports/reports.module').then((m) => m.ReportsModule),
  },
  {
    path: 'report-single',
    canActivate: [AuthGuard], // optional zusätzlich canLoad
    loadChildren: () =>
      import('./pages/report-single/report-single.module').then(
        (m) => m.ReportSingleModule
      ),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      paramsInheritanceStrategy: 'always',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
